import { UiOption } from '@/lib/helpers';
import { PropModel } from '../prop.model';
import { has } from 'lodash';
import { ControlActionValue } from './controls';

export type MetadataControlType = 'non-business-class' | 'non-licensed' | 'enforce-data-privacy';

type MetadataControlEntity = {
  type: MetadataControlType;
  action: ControlActionValue;
};

export const MetadataActionOptions: Map<MetadataControlType, UiOption[]> = new Map();

MetadataActionOptions.set('non-business-class', [
  { label: 'Allow', value: 'allow', meta: { header: true } },
  { label: 'Ignore', value: 'ignore' },
  { label: 'Monitor', value: 'log' },
  { label: 'Warn', value: 'warn' },
  { label: 'Disallow', value: 'disallow', meta: { header: true } },
  { label: 'Block', value: 'block' },
]);

MetadataActionOptions.set('non-licensed', [
  { label: 'Allow', value: 'allow', meta: { header: true } },
  { label: 'Ignore', value: 'ignore' },
  { label: 'Monitor', value: 'log' },
  { label: 'Warn', value: 'warn' },
  { label: 'Disallow', value: 'disallow', meta: { header: true } },
  { label: 'Block', value: 'block' },
]);

MetadataActionOptions.set('enforce-data-privacy', [
  {
    label: 'Enabled',
    value: 'enabled',
    meta: {
      recommended: true,
    },
  },
  {
    label: 'Disabled',
    value: 'disabled',
  },
]);

export class MetadataControlConfig extends PropModel {
  entities?: MetadataControlEntity[];
  forceDataPrivacy?: boolean;
  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof MetadataControlConfig, unknown>;

    if (has(data, 'forceDataPrivacy')) {
      this.forceDataPrivacy = !!data.forceDataPrivacy;
    }

    if (data.entities) {
      this.entities = data.entities as MetadataControlEntity[];
    }
  }
}

export const getMetadataControlActionOptions = (controlType: MetadataControlType): UiOption[] =>
  MetadataActionOptions.get(controlType) || [];
